(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["registro-garantia-estendida"] && !Shopify.designMode) return;
  try {
    
var api_url = 'https://api-frete.vercel.app';
var api_url_register = 'https://api.elements.com.br';
const ZENDESK_URL = 'https://zendesk-endpoint.vercel.app/api/create-ticket';

/* ======================= Estrelas ======================= */
const stars = document.querySelectorAll('.star');
const star_value = document.querySelector('.star_value');
stars.forEach((star,index)=>{
  star.addEventListener('click',()=>{
    let current_star_level = index + 1;
    star_value.value = current_star_level;
    stars.forEach((star2, index2)=>{
      star2.innerHTML = (current_star_level >= index2 + 1) ? '&#9733;' : '&#9734;';
    });
  });
});

/* ======================= Busca de produtos ======================= */
const produtos = document.querySelector('#produtos');
const searchResult = document.querySelector('.search_result');

async function getOrder(value) {
  const response = await fetch(`${api_url}/products`, { method: "POST" });
  const result = await response.json();
  const filteredProducts = result.filter(product =>
    product.title.toLowerCase().includes(value.toLowerCase()) && !product.title.toLowerCase().includes('open box')
  );
  let template = '';
  template = (filteredProducts.length > 0)
    ? filteredProducts.map(product => `<div data-name="${product.title}" class="getName">${product.title}</div>`).join('')
    : `<div>Produto não encontrado!</div>`;
  searchResult.innerHTML = template;
}
function selectProduct(productName) {
  produtos.value = productName;
  searchResult.classList.add('hideNone');
}
searchResult.addEventListener("click", (event) => {
  const target = event.target;
  if (target.classList.contains('getName')) selectProduct(target.dataset.name);
});
if (produtos) {
  produtos.addEventListener("input", async() => { await getOrder(produtos.value); });
}

/* ======================= Cancelar ======================= */
var btn_cancelar = document.querySelector('.btn_cancelar');
function canceledForm(){
  sessionStorage.removeItem('email_customer_no_register');
  sessionStorage.removeItem('email_customer_yes_register');
  sessionStorage.removeItem('email_customer_not_register_2');
  sessionStorage.removeItem('newCustomerEmail');
  sessionStorage.removeItem('orderId');
  sessionStorage.removeItem('newCustomerName');
  sessionStorage.removeItem('email_customer_register');
  sessionStorage.removeItem('maketplace');
}
if (btn_cancelar){
  btn_cancelar.addEventListener("click", () => { canceledForm(); });
}

/* ======================= Seleção de loja ======================= */
async function getStore(store){
  document.querySelector('.number_order').value='';
  document.querySelector('.btn_registrar_cadastrado').style.display="block";
  var pedido = document.querySelector('.pedido');
  var fiscal = document.querySelector('.fiscal');
  var fiscalImg = document.querySelector('.fiscalImg');
  var produtoNome = document.querySelector('.produto_nome');
  var qty = document.querySelector('.qty');
  if(store == 'Elements'){
    elementsStore(pedido,fiscal,fiscalImg,produtoNome,qty);
  } else {
    otherStore(pedido,fiscal,fiscalImg,produtoNome,qty);
  }
}
function otherStore(pedido,fiscal,fiscalImg,produtoNome,qty){
  fiscal.classList.add('showBlock');
  fiscalImg.classList.add('showBlock');
  produtoNome.classList.add('showBlock');
  qty.classList.add('showBlock');
  pedido.classList.add('hideNone');
  pedido.classList.remove('showBlock');
  fiscal.classList.remove('hideNone');
  fiscalImg.classList.remove('hideNone');
  produtoNome.classList.remove('hideNone');
  qty.classList.remove('hideNone');
  sessionStorage.setItem('maketplace', 'maketplace');
}
function elementsStore(pedido,fiscal,fiscalImg,produtoNome,qty){
  fiscal.classList.add('hideNone');
  fiscalImg.classList.add('hideNone');
  produtoNome.classList.add('hideNone');
  qty.classList.add('hideNone');
  fiscal.classList.remove('showBlock');
  fiscalImg.classList.remove('showBlock');
  produtoNome.classList.remove('showBlock');
  qty.classList.remove('showBlock');
  pedido.classList.add('showBlock');
  pedido.classList.remove('hideNone');
  sessionStorage.removeItem('maketplace');
}
var webSite = document.querySelector('#web-sites');
if (webSite){
  webSite.addEventListener('change', async(e)=>{
    var store = e.target.value;
    await getStore(store);
  });
}

/* ======================= Fluxos de cliente ======================= */
function customer_not_regiter(email){
  sessionStorage.removeItem('orderId');
  sessionStorage.removeItem('email_customer_yes_register');
  sessionStorage.setItem('newCustomerEmail', email);
  sessionStorage.setItem('maketplace', 'maketplace');
  window.location.href = '/pages/register';
}
async function customer_register_not_order(email){
  try {
    const response = await fetch(`${api_url}/customer/${email}`,{method: "POST"});
    const result = await response.json();
    const getCustomer = await getCustomerAppHiko(email);
    if(result.length > 0 && result[0].first_name && result[0].last_name){
      return customer_contains_account(result);
    }
    if(getCustomer?.google){
      var data =[{
        first_name: getCustomer.google.first_name,
        last_name: getCustomer.google.last_name ?? getCustomer.google.first_name,
        email: email
      }];
      return customer_contains_account(data);
    }
    customer_not_regiter(email);
  } catch (error) {
    console.log(error);
  }
}
async function getCustomerAppHiko(email){
  const response = await fetch(`https://customer-hiko.vercel.app/customer/${email}`);
  const result = await response.json();
  return result;
}
function customer_contains_account(info){
  var email = info[0].email;
  sessionStorage.removeItem('orderId');
  sessionStorage.removeItem('email_customer_not_register_2');
  sessionStorage.removeItem('email_customer_no_register');
  sessionStorage.setItem('email_customer_register', JSON.stringify(info[0]));
  sessionStorage.setItem('email_customer_yes_register', 'yes_register');
  sessionStorage.setItem('maketplace', 'maketplace');
  sessionStorage.setItem('newCustomerEmail', email);
  window.location.reload();
}
function customer_regiter_contains_order(data){
  var email = data[0].email;
  sessionStorage.removeItem('orderId');
  sessionStorage.removeItem('email_customer_not_register_2');
  sessionStorage.removeItem('email_customer_no_register');
  sessionStorage.setItem('email_customer_register', JSON.stringify(data[0]));
  sessionStorage.setItem('email_customer_yes_register', 'yes_register');
  sessionStorage.setItem('maketplace', "maketplace");
  sessionStorage.setItem('newCustomerEmail', email);
  sessionStorage.setItem('newCustomerName', data[0].shipping_address.first_name + " " + data[0].shipping_address.last_name);
  window.location.reload();
}
async function customer_contains_order(email){
  try {
    const response = await fetch(`${api_url}/order/${email}`,{method: "POST"});
    const result = await response.json();
    if(result.length > 0){
      customer_regiter_contains_order(result);
    }else{
      await customer_register_not_order(email);
    }
  } catch (error) { console.log(error); }
}

/* botão "Próximo" */
var btnGarantia = document.querySelector('.btn_garantia');
if(btnGarantia){
  btnGarantia.addEventListener('click', async(e)=>{
    e.preventDefault();
    var emailGarantia = document.querySelector('.email_garantia');
    var email = emailGarantia.value;
    if(emailGarantia.value === ""){
      alert("Preencha o campo do email");
    }else{
      document.querySelector('.loader_garantia_base').classList.remove('hideLoader');
      await customer_contains_order(email);
    }
  });
}

/* utilitário de sessão */
function sessionStorageItem(){
  var customer = sessionStorage.getItem('email_customer_yes_register');
  var customerData = sessionStorage.getItem('email_customer_register');
  var data =JSON.parse(customerData);
  var name = data ? data?.first_name +" "+ data?.last_name:null;
  var email = sessionStorage.getItem('newCustomerEmail');
  var orderId = JSON.parse(sessionStorage.getItem('orderId'));
  var order = JSON.parse(sessionStorage.getItem('order'));
  const newcustomer = sessionStorage.getItem('newCustomerName');
  return { email, customer,name,data, orderId, order,newcustomer};
}
const customerDataExist = sessionStorageItem();

/* mostrar/esconder blocos */
if(customerDataExist.email){
  document.querySelector('.form_email_base').style.display="block";
}
if(customerDataExist.customer || customerDataExist.newcustomer){
  document.querySelector('.cadastrado').style.display="flex";
  document.querySelector('.form_email_base').style.display="none";
}
if(customerDataExist.name || customerDataExist.newcustomer) {
  document.querySelector('.cadastrado').style.display="flex";
  document.querySelector('.form_email_base').style.display="none";
  document.querySelector('.check_email').innerHTML=customerDataExist.email;
  document.querySelector('.check_name').innerHTML=customerDataExist.name;
}

/* ======= Sucesso/erros ======= */
function sucess_remove(){
  document.getElementById('garantia_spinner').style.display="none";
  document.getElementById("form_garantia_cadastrada").reset();
  document.querySelector(".register_sucess").style.display="block";
  sessionStorage.removeItem('orderId');
  sessionStorage.removeItem('email_customer_register');
  sessionStorage.removeItem('email_customer_not_register_2');
  sessionStorage.removeItem('email_customer_no_register');
  sessionStorage.removeItem('email_customer_yes_register');
  sessionStorage.removeItem('newCustomer');
  document.getElementById("form_garantia_cadastrada").style.display="none";
  sessionStorage.removeItem('maketplace');
  sessionStorage.removeItem('newCustomerName');
}
function showError(response){ alert(response); window.location.reload(); }
function formError(response){
  if (response == "fiscal exist"){
    showError('Nota fiscal já foi cadastrada!');
  }else if (response == "serial exist"){
    showError('Número serial já foi cadastrado!');
  }else if ( response =='Falha ao enviar arquivo'|| response == "Falha ao enviar arquivo" || response == "Arquivo muito grande! Max: 2MB" || response == "Tipo de arquivo não aceito! Válido: jpeg, jpg, pdf, png" ){
    showError(response);
  }else if (response == "order exist"){
    showError('Número pedido já foi cadastrado!');
  }else{
    showError('Parece que houve um erro no cadastro da garantia. Vamos tentar novamente. Por favor');
  }
}

/* ======= Helpers Zendesk ======= */
function cloneFormData(fd){
  const c = new FormData();
  for (const [k,v] of fd.entries()) c.append(k,v);
  return c;
}
function enrichFormDataForZendesk(fd, ctx) {
  const subject = `Garantia Estendida | ${fd.get('website') || '—'} | Pedido ${fd.get('pedido') || 'N/A'}`;
  const summary = [
    `Nome: ${ctx.fullName || '—'}`,
    `Email: ${ctx.email || '—'}`,
    `Canal: ${fd.get('website') || '—'}`,
    `Pedido: ${fd.get('pedido') || '—'}`,
    `Serial: ${fd.get('serial') || '—'}`,
    `Produto: ${fd.get('produto') || '—'}`,
    `Qtde: ${fd.get('qty') || '—'}`,
    `Nota Fiscal: ${fd.get('fiscal') || '—'}`,
    `Rede Social: ${fd.get('social') || '—'}`,
    `URL: ${fd.get('link') || '—'}`,
    `Avaliação: ${fd.get('rate') || '0'} estrelas`,
    `Origem: /pages/garantia_estendida`
  ].join('\n');

  fd.append('subject', subject);
  fd.append('message', summary);

  // extras úteis como custom fields
  if (fd.get('website') && !fd.get('loja')) fd.append('loja', fd.get('website'));
  if (fd.get('pedido') && !fd.get('numero_pedido')) fd.append('numero_pedido', fd.get('pedido'));
  if (fd.get('serial') && !fd.get('numero_serial')) fd.append('numero_serial', fd.get('serial'));
  if (fd.get('produto') && !fd.get('produto_nome')) fd.append('produto_nome', fd.get('produto'));
  if (fd.get('qty') && !fd.get('quantidade')) fd.append('quantidade', fd.get('qty'));
  if (fd.get('fiscal') && !fd.get('nota_fiscal')) fd.append('nota_fiscal', fd.get('fiscal'));
  if (fd.get('social') && !fd.get('rede_social')) fd.append('rede_social', fd.get('social'));
  if (fd.get('link') && !fd.get('url')) fd.append('url', fd.get('link'));

  fd.append('tags[]', 'garantia_estendida');
  return fd;
}

/* ======= Envio (DB + Zendesk) ======= */
async function registerData(formData){
  try {
    console.log('>> Enviando (DB + Zendesk):', [...formData.entries()]);
    const fdZendesk = cloneFormData(formData);

    const [dbReq, zdReq] = await Promise.allSettled([
      fetch(`${api_url_register}/adiciona-action.php`, { method: 'POST', body: formData }),
      fetch(ZENDESK_URL, { method: 'POST', body: fdZendesk })
    ]);

    // trata retorno do DB
    let okDB = false, rawDB = '';
    if (dbReq.status === 'fulfilled') {
      rawDB = await dbReq.value.text();
      let resultDB;
      try { resultDB = JSON.parse(rawDB); } catch { resultDB = { raw: rawDB }; }
      console.log('<< DB', dbReq.value.status, resultDB);
      okDB = (dbReq.value.ok && resultDB.status == 200 && resultDB.msg === 'success');
      if (!okDB) {
        document.getElementById('garantia_spinner').style.display="none";
        return formError(resultDB.msg || resultDB.error || resultDB.raw || `Falha HTTP ${dbReq.value.status}`);
      }
    } else {
      document.getElementById('garantia_spinner').style.display="none";
      return alert('Erro de rede ao enviar (DB): ' + dbReq.reason?.message || dbReq.reason);
    }

    // log do Zendesk (não bloqueia sucesso do DB)
    if (zdReq.status === 'fulfilled') {
      const text = await zdReq.value.text().catch(()=> '');
      let json; try { json = JSON.parse(text); } catch { json = { raw: text }; }
      console.log('<< Zendesk', zdReq.value.status, json);
    } else {
      console.warn('Zendesk falhou:', zdReq.reason);
    }

    if (okDB) sucess_remove();
  } catch (err) {
    document.getElementById('garantia_spinner').style.display="none";
    alert('Erro de rede: ' + err.message);
  }
}

async function registerElements(formData){
  if(formData.get('pedido') == '') return alert('Número de pedido é obrigatório');
  if(formData.get('serial') == '') return alert('Número de serial é obrigatório');
  if(formData.get('social') == '') return alert('Rede social é obrigatório');
  if(formData.get('link') == '') return alert('Link é obrigatório');
  if(formData.get('rate') == '') return alert('Avaliação é obrigatório');
  document.getElementById('garantia_spinner').style.display="grid";
  await registerData(formData);
}
async function registerOuther(formData){
  const file = formData.get('arquivo');
  if(formData.get('serial') == '') return alert('Número de serial é obrigatório');
  if(formData.get('produto') == '') return alert('Nome do produto é obrigatório');
  if(formData.get('social') == '') return alert('Rede social é obrigatório');
  if(formData.get('fiscal') == '') return alert('Número de nota fiscal é obrigatório');
  if(!file || (file && file.size === 0)) return alert('Arquivo é obrigatório');
  if(formData.get('link') == '') return alert('Link é obrigatório');
  if(formData.get('rate') == '') return alert('Avaliação é obrigatório');
  document.getElementById('garantia_spinner').style.display="grid";
  await registerData(formData);
}

/* ======= Submit ======= */
const formSubmit = document.getElementById('form_garantia_cadastrada');
function inputVerifyError(response){ alert(response); window.location.reload(); }
function inputVerify(formData){
  if((formData.get('pedido')||'').length > 10){ return { status: 500, msg: 'Número pedido está muito longo.' }; }
  if((formData.get('serial')||'').length > 30){ return { status: 500, msg: 'Número serial está muito longo.' }; }
  if((formData.get('link')||'').length > 350){ return { status: 500, msg: 'Link está muito longo.' }; }
  if((formData.get('link')||'').length > 0 && (formData.get('link')||'').length < 20){ return { status: 500, msg: 'Link está muito curto.' }; }
  if((formData.get('produto')||'').length > 100){ return { status: 500, msg: 'O nome do produto está muito longo.' }; }
  return { status: 200, msg: 'success' };
}
if(customerDataExist.email){
  formSubmit.addEventListener("submit", async(e) => {
    e.preventDefault();
    const fullName = (document.querySelector('.check_name')?.innerText || '').trim();
    const fd = new FormData(formSubmit);
    // normaliza nome/email/pedido
    fd.set('nome', fullName);
    fd.set('email', customerDataExist.email || '');
    if(customerDataExist.orderId){ fd.set('pedido', customerDataExist.orderId); }
    // enriquece p/ Zendesk
    enrichFormDataForZendesk(fd, { fullName, email: customerDataExist.email });

    const website = fd.get('website');
    if(!website){ alert('website é obrigatório'); return; }

    const verify = inputVerify(fd);
    if(verify.status !== 200){ inputVerifyError(verify.msg); return; }

    if(website === 'Elements'){ await registerElements(fd); }
    else { await registerOuther(fd); }
  });
}else{
  formSubmit.addEventListener("submit", async(e) =>{
    e.preventDefault();
    alert('Parece que houve um erro no cadastro da garantia. Vamos tentar novamente. Por favor');
  });
}

/* ======= Pedidos existentes ======= */
async function customerOrderExist() {
  if(customerDataExist.email){
    try {
      const response = await fetch(`${api_url}/order/${customerDataExist.email}`,{method: "POST"});
      const result = await response.json();
      sessionStorage.setItem('list_orders', JSON.stringify(result));
    } catch (error) { console.log(error); }
  }else{
    sessionStorage.setItem('list_orders', '[]');
  }
}
customerOrderExist();

var btn_registrar_cadastrado = document.querySelector('.btn_registrar_cadastrado');
var numero = document.querySelector('.number_order');
function filterNumero(){
  var list_orders_active = JSON.parse(sessionStorage.getItem('list_orders') || '[]');
  if(list_orders_active.error){
    document.querySelector('.error_number').style.display="block";
    document.querySelector('.error_number').innerHTML="Não existe pedido com seu e-mail.";
    btn_registrar_cadastrado.style.display="none";
  }else{
    var order = list_orders_active.find(es => es.order_number == Number(numero.value));
    if(order){
      btn_registrar_cadastrado.style.display="block";
      sessionStorage.setItem('orderId', JSON.stringify(order.order_number));
      sessionStorage.setItem('order', JSON.stringify(order));
      var orderId = JSON.parse(sessionStorage.getItem('orderId'));
      numero.value= orderId;
      document.querySelector('.error_number').innerHTML="Número de pedido válido.";
      document.querySelector('.error_number').style.color="green";
      window.location.reload();
    }else{
      document.querySelector('.error_number').innerHTML="Por favor, Digite um número de pedido válido.";
      document.querySelector('.error_number').style.display="block";
      document.querySelector('.error_number').style.color="red";
    }
  }
}
if (numero){
  numero.addEventListener('focusout', filterNumero);
  numero.addEventListener('keyup', filterNumero);
}

/* aplicar pedido */
function applyOrderIdToInput(){
  if(customerDataExist.orderId){
    numero.value = customerDataExist.orderId;
    document.querySelector('.pedido').style.display="block";
    if (webSite) webSite.value="Elements";
  }
}
applyOrderIdToInput();

/* preencher labels */
function addInfoCustomerToLabel(){
  if(customerDataExist.email && customerDataExist.name !== "undefined undefined"){
    document.querySelector('.check_email').innerHTML=customerDataExist.email;
    document.querySelector('.check_name').innerHTML=customerDataExist.name;
  }else{
    document.querySelector('.check_email').innerHTML=customerDataExist.email || '';
    document.querySelector('.check_name').innerHTML= customerDataExist.newcustomer || '';
  }
  if(sessionStorage.getItem('newCustomerName')){
    document.querySelector('.check_name').innerHTML= sessionStorage.getItem('newCustomerName');
  }
}
addInfoCustomerToLabel();

/* resetar ao clicar no logo */
var logo_click = document.querySelector('.header__heading-link');
if (logo_click){
  logo_click.addEventListener("click", () => { canceledForm(); });
}

  } catch(e) { console.error(e); }
})();
})();
